import { Common, color } from '@stockbit/ui';
import { useRouter } from 'next/router';

import { PROJECT_FOLDER_PATH } from 'constants/app';
import useChatStore from 'stores/chat';
import { useGetChatUnreadCount } from 'stores/chat/useGetChatUnreadCount';
import { DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT_SEE_ALL_BUTTON } from './__tests__/constant';
import {
  CustomPopoverContainer,
  PopoverContentMobile,
  PopoverFooter,
} from './styled';
import MessageHeader from './MessageHeader';
import MessageList from './MessageList';
import MessageIcon from './MessageIcon';

const { Popover } = Common;

const Mobile = () => {
  const router = useRouter();
  const unreadCount = useGetChatUnreadCount((s) => s.count);
  const unreadRequest = useChatStore((s) => s.rooms.default.unreadRequest);

  // Event handlers
  const handleSeeAllClick = () => {
    router.push(`${window.location.origin}${PROJECT_FOLDER_PATH}/chat`);
  };

  const Footer = (
    <PopoverFooter
      onClick={handleSeeAllClick}
      data-cy={DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT_SEE_ALL_BUTTON}
    >
      See All in Chat
    </PopoverFooter>
  );

  return (
    <Popover
      trigger="click"
      placement="bottom"
      getPopupContainer={(trigger) => trigger.parentElement}
      overlayInnerStyle={{
        borderBottom: 'unset',
      }}
      content={() => (
        <CustomPopoverContainer>
          <div style={{ borderBottom: `1px solid ${color.gainsboro}` }}>
            <MessageHeader unreadRequest={unreadRequest} />
            <PopoverContentMobile>
              <MessageList />
            </PopoverContentMobile>
            {Footer}
          </div>
        </CustomPopoverContainer>
      )}
    >
      <MessageIcon count={unreadCount} />
    </Popover>
  );
};

export default Mobile;
